module.exports = __webpack_public_path__ + "static/media/footer_chat_black.3dc80b3b.png";